<template>
    <div>
        <template v-if="isEmbed">
            <CRMOrderStateControl
                ref="stateControl"
                @visible="visible = $event"
                @showEmptyParts="showEmptyParts"
            />
            <BrokenPartsModal
                v-if="showBrokenPartsModal"
                :parts="emptyParts"
                :book="book"
                :confirmable="false"
                no-redirect
                @closed="showBrokenPartsModal = false"
            />
        </template>
        <slot :orderStateControlVisible="visible" />
    </div>
</template>

<script>
import CRMOrderStateControl from '../../components/CRMOrderStateControl/CRMOrderStateControl';
import { BrokenPartsModal } from '@speechki-frontend/core/book/components';

import { mapState } from 'vuex';

const crmBaseUrl = process.env.VUE_APP_CRM_API_URL;

export default {
    name: 'CRMOrderStateControlWrapper',
    components: {
        CRMOrderStateControl,
        BrokenPartsModal
    },
    inject: {
        isEmbed: {
            default: false
        }
    },
    provide() {
        const customerSettings = {};

        Object.defineProperty(customerSettings, 'settings', {
            enumerable: true,
            get: () => this.customerSettings.settings
        });

        return { customerSettings };
    },
    data() {
        return {
            emptyParts: [],
            visible: false,
            showBrokenPartsModal: false,

            customerSettings: {
                settings: {
                    name: ''
                }
            }
        };
    },

    computed: {
        ...mapState({
            book: ({ book }) => book.book
        })
    },
    watch: {
        emptyParts(parts) {
            this.showBrokenPartsModal = parts.length > 0;
        }
    },
    created() {
        this.checkTheme(this.$store.getters['guestAccess/customerId']);
    },
    methods: {
        showEmptyParts(parts) {
            this.emptyParts = parts;
        },
        returnFromEmbed() {
            const destination = sessionStorage.getItem('comeback_url');
            if (destination) {
                window.location.href = decodeURIComponent(destination);
            }
        },
        async checkTheme(customer) {
            try {
                // eslint-disable-next-line @speechki/eslint-plugin/no-axios-plugin
                this.customerSettings = await this.$http.get(
                    `${crmBaseUrl}/api/v1/customers/customers_style_settings/${customer}/`
                );
                if (this.customerSettings.settings && this.customerSettings.settings.name) {
                    document.body.classList.add(`theme-${this.customerSettings.settings.name}`);
                }
            } catch (e) {
                console.log(e);
            }
        }
    }
};
</script>
